import * as R from 'ramda';
import { IJsonQuery } from '@cian/api-models/common/json_query';

import { EFacilityType, NonEmptyArray } from './types';
import { resetTerms, setTerm } from './helpers';

export function setSuburbanFacilityTypes(jsonQuery: IJsonQuery) {
  return (facilityTypes: NonEmptyArray<EFacilityType> | null): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['bathhouse', 'garage', 'security', 'pool'])(nextJsonQuery);

    if (facilityTypes) {
      if (facilityTypes.includes(EFacilityType.Sauna)) {
        nextJsonQuery = setTerm('bathhouse')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Garage)) {
        nextJsonQuery = setTerm('garage')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Security)) {
        nextJsonQuery = setTerm('security')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Pool)) {
        nextJsonQuery = setTerm('pool')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
